module.exports = __webpack_public_path__ + "img/tizen-digital-signage.e65eefa4.png";